export default __webpack_public_path__ + "5cf66e3e7d129daddc6d9c35bc310f7b.svg";